import { TipoMinuta } from "../TipoMinuta";
const TIPOS_MINUTAS = new Map([
    ['Acórdão', TipoMinuta.VOTO],
    ['Despacho', TipoMinuta.DESPACHO],
    ['Decisão', TipoMinuta.DECISAO]
])

export class TipoPeca {
    readonly tipoMinuta?: TipoMinuta;
    constructor(
        readonly descricao: string) {
        this.tipoMinuta = TIPOS_MINUTAS.get(descricao);
    }
}